$(function () {

  if($('.invite-referral-page-container').length === 0 &&
    $(".privacy-policy-page-container").length === 0 &&
    $(".welcome-page-container").length === 0 &&
    $(".welcome-faq-page-container").length === 0) return;

  $('.open-menu-btn').click(function () {
    $('.mob-menu-overlay').addClass('visible');
    $('.open-menu-btn').hide();
    $('.close-menu-btn').show();
  });

  $('.close-mob-menu-btn, .close-menu-btn').click(function () {
    $('.mob-menu-overlay').removeClass('visible');
    $('.open-menu-btn').show();
    $('.close-menu-btn').hide();
  });
})